import { render, staticRenderFns } from "./AdvertiseSizeIndex.vue?vue&type=template&id=de865208"
import script from "./AdvertiseSizeIndex.vue?vue&type=script&lang=js"
export * from "./AdvertiseSizeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports